import React, { Component } from "react";
import "./Progress.css";

class Progress extends Component {
	render() {
		return (
			<div className="onboarding-progress">
			<p className="progress-num">{this.props.onboardingStepBuyer + 1} of {Object.keys(this.props.onboardingFlowBuyer).length}</p>
			<h2 className="mb-20">{this.props.onboardingFlowBuyer[this.props.onboardingStepBuyer]}</h2>
			</div>
		);
	}
}

export default Progress;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Progress/Progress.js